var styleDataHash = "705b4341";
const injectCss = () => {
  var css = `.VMk4V{box-sizing:border-box;display:flex;flex-direction:column;width:162px;z-index:10}[dir] .VMk4V{background-color:#fff}.VMk4V *,.VMk4V :after,.VMk4V :before{box-sizing:inherit}.VMk4V input{box-sizing:border-box}@supports not (contain:inline-size){@media only screen and (max-width:640px){.VMk4V{width:100%}}}@container (width < 640px){.VMk4V{width:100%}}.yMQpe{align-items:flex-start;align-items:center;display:flex;flex-direction:column;width:100%}[dir] .yMQpe{padding:8px 0}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var DropdownModal_default = {
  "modal": "VMk4V",
  "dropdownModalOptionsWrapper": "yMQpe"
};
export {
  DropdownModal_default as default,
  injectCss
};
//# sourceMappingURL=DropdownModal-scss.js.map
